import React, { useEffect } from "react";
import { CircularProgress, Typography, Box } from "@mui/material";
import AuthenticationService from "../AuthenticationService";
import {
  setActivePage,
  setAuthentication,
  setLayout,
  setAssignTo,
} from "context";
import { useMaterialUIController } from "context";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import loggerFactory from "globals/logger/logger-factory";

const EAMSLogin = () => {
  const [controller, dispatch] = useMaterialUIController();
  const { activePage } = controller;
  const navigate = useNavigate();

  const encryptData = (data, secretKey) => {
    const iv = CryptoJS.lib.WordArray.random(16);
    const ciphertext = CryptoJS.AES.encrypt(
      data,
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        iv: iv,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return iv.concat(ciphertext.ciphertext).toString(CryptoJS.enc.Base64);
  };

  useEffect(() => {
    const handleLoginResponse = (data) => {
      if (!data.token || !data.refreshToken) {
        console.error("Invalid login response:", data);
        return;
      }

      AuthenticationService.storeAuthenticationDetails(
        data.sipPhoneButton,
        data.token,
        data.refreshToken,
        data.userName,
        data.fullName,
        data.roles,
        data.menu,
        data.coralApplication,
        {
          extensionName: data.extensionName,
          extension: data.extension,
          sipPassword: data.sipPassword,
        },
        data.rluCode,
        data.rluIp,
        data.pwdComplication,
        data.userId,
        data.ringAnswerCount,
        data.publicEmergencyNumber,
        data.broadcastNumber,
        data.wssDomain,
        data.mapUrl,
        data.mapCenter,
        data.mapDefaultZoom,
        data.mapMinZoom,
        data.mapMaxZoom,
        data.xmPPPrimaryDomain,
        data.departmentList,
        data.idealTimeout,
        data.description,
        data.appMode,
        data.enableTTS,
        data.disableContextBasedGui,
        data.turnServerUrl,
        data.turnUserName,
        data.turnPassword,
        {
          currencySymbol:      data?.currencySymbol,
          decimalSeparator:    data?.decimalSeparator,
          groupingSeparator:   data?.groupingSeparator,
          groupingStyle:       data?.groupingStyle,
          taxLabel:            data?.taxLabel,
          taxRounding:         data?.taxRounding,
          roundingMode:        data?.roundingMode,
          amountInWords:       data?.amountInWords,
          currencyWord:        data?.currencyWord,
          currencyFractionWord: data?.currencyFractionWord,
        },
      );

      window.sessionStorage.setItem(
        `${window.location.hostname}-coral-X-User`,
        encryptData(data.username, window.secretKey)
      );

      setAssignTo(dispatch, "bc4c2c03177f7844c001511aa16f331f");
      activePage.key = "dashboard.controller";
      activePage.name = "dashboardController";
      activePage.url = "/app/dashboardController/home";
      activePage.description = "Dashboard Controller";
      activePage.authenticationStatus = true;
      setActivePage(dispatch, activePage);
      setAuthentication(dispatch, true);
      setLayout(dispatch, "dashboard");
      navigate("/app/home", { replace: true });
    };

    const handleMessage = (event) => {
        loggerFactory.info("EAMS Event Received: " , event?.data)
      if (event?.data?.eventType === "loginResponse") {
        console.log("Login response received:", event.data);
        handleLoginResponse(event.data.data);
      }  else {
        console.error("Unexpected event data:", event.data);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [activePage, dispatch, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CircularProgress size={60} thickness={4} color="info" />
      <Typography
        variant="h6"
        sx={{ marginTop: 2, color: "text", fontSize: "25px" }}
      >
        Please wait, we are authenticating you...
      </Typography>
    </Box>
  );
};

export default EAMSLogin;
